angular.module( 'acme.view.application.orders.requests.edit', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.view.application.orders.requests.edit.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var ordersRequestsCreate = {
        name: 'application.orders.requests.create',
        url: '/create?orgId',
        views: {
          "subview-main": {
            controller: 'OrdersRequestsEditController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/orders/requests/edit/edit.tpl.html'
          }
        },
        data: {
          pageTitle: 'Create Order Request',
          enablePreferences: true
        },
        resolve: {
          OrderData: ['$stateParams', 'ApiService', function ($stateParams, ApiService) {
            return {data: {success: false}};
          }],
          CustomFieldsData: ['ApiService', 'HelpersService', function (ApiService, HelpersService) {
            return ApiService.customFields.list(HelpersService.getPaginator());
          }]
        }
      },
    ordersRequestsEdit = {
      name: 'application.orders.requests.edit',
      url: '/:id/edit',
      views: {
        "subview-main": {
          controller: 'OrdersRequestsEditController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/orders/requests/edit/edit.tpl.html'
        }
      },
      data: {
        pageTitle: 'Edit Order Request',
        enablePreferences: true
      },
      resolve: {
        OrderData: ['$stateParams', 'ApiService', function ($stateParams, ApiService) {
          return ApiService.orders.requests.detail($stateParams.id);
        }],
        CustomFieldsData: ['ApiService', 'HelpersService', function (ApiService, HelpersService) {
          return ApiService.customFields.list(HelpersService.getPaginator());
        }]
      }
    };

    $stateProvider
      .state(ordersRequestsCreate)
      .state(ordersRequestsEdit);
});
